export const capitalise = (text: string): string =>
  `${text.charAt(0).toUpperCase()}${text.slice(1)}`;

export const atAge = (age: number): string => `at age ${age}`;

export const atAgeStartingSentence = (age: number): string => capitalise(atAge(age));

export const runsOutAtAge = (age: number): string => `runs out ${atAge(age)}`;

export const runsOutAtAgeStartingSentence = (age: number): string => capitalise(runsOutAtAge(age));

export const runsOutInYear = (year: number): string => `runs out in ${year}`;

export const runsOutInYearStartingSentence = (year: number): string =>
  capitalise(runsOutInYear(year));

export const RUNS_OUT = 'runs out';
export const RUNS_OUT_STARTING_SENTENCE = capitalise(RUNS_OUT);

export const ranOutAtAge = (age: number): string => `ran out ${atAge(age)}`;
export const NEVER_RUNS_OUT_TEXT = 'Not within the plan';
